import React, { useState, useEffect } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Nav, NavDropdown, Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import styled from "styled-components";
import logo_y from "../../../images/homepage_new/SubLogo.png";
import DeviceUtils from "../../../helper/DeviceUtils";
import { Icon } from "semantic-ui-react";
import Popup from "reactjs-popup";
import TimecodeShiftMainView from "../../layout/TimecodeShift/TimecodeShiftMainView";

const NavView = styled.div`
  padding-top: ${(props) => props.paddingTop}px;
  background-color: #ffffff00;
  height: ${(props) => props.height}px;
  position: relative;
`;

const FormtitleLable = styled.div`
  width: ${(props) => props.width}px;
`;

const HomeHeader = () => {
  const location = useLocation();
  const history = useHistory();

  const menuArray = ["About", "Service", "Work", "Event", "Contact"];
  const urlArray = ["aboutpage", "services", "work", "event", "contactus"];
  // const menuArray = [ "About","Service","Work","Contact"];
  // const urlArray = [ "aboutpage","services","work","contactus" ];
  const [menuIndex, setmenuIndex] = useState(4);
  const [isShowPhoneMenu, setisShowPhoneMenu] = useState(false);

  const mainWidth =
    DeviceUtils.isMobile() === false ? window.innerWidth : window.innerWidth;

  //網址判斷
  useEffect(() => {
    const currentPath = location.pathname;
    const searchParams = new URLSearchParams(location.search);
    if (currentPath.includes("aboutpage")) {
      setmenuIndex(0);
    } else if (currentPath.includes("services")) {
      setmenuIndex(1);
    } else if (currentPath.includes("work")) {
      setmenuIndex(2);
    } else if (currentPath.includes("event")) {
      setmenuIndex(4);
    } else if (currentPath.includes("contactus")) {
      setmenuIndex(5);
    } else {
      setmenuIndex(6);
    }
    //console.log(`location currentPath ${currentPath} searchParams ${searchParams} `);
  }, [location]);

  /**
   * 開啟 Timecode shift 設定
   * */
  const PhoneMenuAlertView = () => {
    return (
      <Popup
        open={isShowPhoneMenu}
        modal
        closeOnDocumentClick
        onClose={() => {
          setisShowPhoneMenu(false);
        }}
        contentStyle={{
          width: `${window.innerWidth}px`,
          height: `${window.innerHeight}px`,
          backgroundColor: "#4890cb",
        }}
      >
        <div className="text-right mt-5 px-4">
          <Icon
            name="cancel"
            size="huge"
            style={{ fontSize: "23px", color: "white" }}
            onClick={() => {
              setisShowPhoneMenu(false);
            }}
          />
        </div>

        <Container style={{ width: `${mainWidth}px` }}>
          <Row>
            {menuArray.map((title, index) => {
              let classname =
                "d-inline HeaderTitle_p mr-2 text-center w-100 mb-5";
              if (menuIndex === index) {
                classname =
                  "d-inline HeaderTitle_selected_p mr-2 text-center w-100 mb-5";
              }

              return (
                <FormtitleLable
                  key={index}
                  width={window.innerWidth - 50}
                  className={classname}
                  onClick={() => {
                    setmenuIndex(index);
                    setisShowPhoneMenu(false);

                    history.push(urlArray[index]);
                  }}
                >
                  {title}
                </FormtitleLable>
              );
            })}
          </Row>
        </Container>
      </Popup>
    );
  };

  return DeviceUtils.isMobile() === false ? (
    <div
      style={{
        zIndex: 100,
        position: "fixed",
        right: 0,
        top: 0,

        backgroundColor: "#000000",
        width: `${window.innerWidth}px`,
        boxShadow: "5px 3px 3px rgba(0,0,0,0.25)",
      }}
      className="overflow-hidden"
    >
      <NavView height={90} paddingTop={0}>
        <div style={{ width: `${mainWidth}px` }} className="overflow-hidden">
          <div style={{ position: "relative", textAlign: "center" }}>
            <Link to={`/`} target="_self">
              <img src={logo_y} alt="Logo" width={346} />
            </Link>

            <Row
              style={{
                position: "absolute",
                top: "0px",
                right: "20px",
                width: "450px",
                marginTop: "40px",
              }}
            >
              {menuArray.map((title, index) => {
                let classname = " HeaderTitle_new text-center pt-2 ";
                if (menuIndex === index) {
                  classname = " HeaderTitle_new_selected text-center pt-2  ";
                }

                return (
                  <Col
                    key={index}
                    // style={{width:`${120}px`}}
                    className={classname}
                    onClick={() => {
                      //history.push(urlArray[index]);

                      setmenuIndex(index);
                    }}
                  >
                    <a className="titleHover" href={`${urlArray[index]}`}>
                      {title}
                    </a>
                  </Col>
                );
              })}
            </Row>
          </div>
        </div>
      </NavView>
    </div>
  ) : (
    //手機
    <div
      style={{
        zIndex: 100,
        position: "fixed",
        right: 0,
        top: 0,

        backgroundColor: "#000000",
        width: `${window.innerWidth}px`,
        boxShadow: "5px 3px 3px rgba(0,0,0,0.25)",
      }}
      className="overflow-hidden"
    >
      <NavView height={130} paddingTop={5}>
        <Container style={{ width: `${mainWidth}px` }} className="p-0 m-0">
          <Row className="p-0 m-0">
            <FormtitleLable
              width={
                DeviceUtils.isMobile() === false ? 300 : window.innerWidth - 50
              }
              className="d-inline pl-3"
            >
              <Link to={`/`} target="_self">
                <img src={logo_y} alt="Logo" width={130} />
              </Link>
            </FormtitleLable>

            {menuArray.map((title, index) => {
              let classname = "d-inline HeaderTitle text-center";
              if (menuIndex === index) {
                classname = "d-inline HeaderTitle_selected text-center";
              }

              return (
                <div
                  key={index}
                  style={{ width: `${180}px` }}
                  className={classname}
                  onClick={() => {
                    //history.push(urlArray[index]);

                    setmenuIndex(index);
                  }}
                >
                  <a href={`${urlArray[index]}`}>{title}</a>
                </div>
              );
            })}
            {/*<FormtitleLable width={50} className="d-inline mt-2  " >*/}
            {/*    <Icon name='align justify'   size='huge' style={{fontSize:"23px" }}  onClick={()=>{*/}
            {/*        setisShowPhoneMenu(true);*/}
            {/*    }}/>*/}
            {/*</FormtitleLable>*/}

            {PhoneMenuAlertView()}
          </Row>
        </Container>
      </NavView>
    </div>
  );
};

export default HomeHeader;



// WEBPACK FOOTER //
// ./src/components/homepage_new/header/HomeHeader.js